import axios from "axios";
import { message as AntdAlert } from "antd";
import { put, all, takeLatest } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import errorHandler from "../../../../components/unauthorizeHandler";
import { getUserTimezone } from "../../../../utils/timeZone";

export function* handleLoginUser({ data }) {
  const { navigate, timezone, ...rest } = data;
  try {
    // Ensure timezone is always sent with login
    const loginData = { ...rest, timezone: timezone || getUserTimezone() };
    const response = yield axios.post(`${baseURL}/auth/signin`, loginData);
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(
        actions.loginUserSuccess({
          user: response.data.data,
          navigate,
          shouldNavigate: true,
        })
      );
    } else {
      AntdAlert.error(message);
      yield put(actions.loginUserError());
    }
  } catch (error) {
    yield put(actions.loginUserError());
    AntdAlert.error('Your Email or Password is incorrect. Please try again.');
    console.log(error);
  }
}


export function* handleLogoutUser({ data }) {
  const { navigate, id } = data;
  try {
    const response = yield axios.post(`${baseURL}/auth/signout`, { id });
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.logoutUserSuccess({ ...response.data.data, navigate }));
      navigate("/");
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.logoutUserError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleFetchSidebarLabs({ data }) {
  try {
    const response = yield axios.get(
      `${baseURL}/user-labs`,
      { params: { userId: data.userId } }
    );
    if (response.status === 200) {
      yield put(actions.fetchSidebarLabSuccess(response.data.UserLabSetups));
    } else {
      yield put(actions.fetchSidebarLabError());
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchSidebarLabError());
    console.log(error);
  }
}